module.exports = __webpack_public_path__ + "img/interviewFinish.fd4bcf32.gif";